"use client";
import * as o from "react";
import { u as s } from "./useRenderElement-B8V3_e8R.mjs";
const i = /* @__PURE__ */ o.forwardRef(function(r, t) {
  const {
    className: m,
    render: c,
    orientation: e = "horizontal",
    ...a
  } = r, n = o.useMemo(() => ({
    orientation: e
  }), [e]);
  return s("div", r, {
    state: n,
    ref: t,
    props: [{
      role: "separator",
      "aria-orientation": e
    }, a]
  });
});
process.env.NODE_ENV !== "production" && (i.displayName = "Separator");
export {
  i as S
};
